(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-banner-image"] && !Shopify.designMode) return;
  try {
    
  const slider = document.querySelector('.continuous-slider-wrapper');
  if (slider) {
    const desktopSpeed = slider.dataset.desktopSpeed;
    const mobileSpeed = slider.dataset.mobileSpeed;
    const setSpeed = () => {
      const isMobile = window.matchMedia('(max-width: 768px)').matches;
      slider.style.setProperty('--scroll-speed', `${isMobile ? mobileSpeed : desktopSpeed}s`);
    };
    setSpeed();
    window.addEventListener('resize', setSpeed);
  }

  } catch(e) { console.error(e); }
})();
})();
